import { components } from 'react-select';
import React from 'react';
import { cloneDeep } from 'lodash';
import logger from 'app/utils/logger';

const SelectValueContainer = ({ children, ...props }: any) => {
  const { getValue, hasValue } = props;
  // const newChildren = cloneDeep(children);
  const nbValues = getValue().length;
  // newChildren[0] = `${nbValues} items selected`;

  if (!hasValue) {
    return <components.ValueContainer {...props}>{children}</components.ValueContainer>;
  } else if (nbValues === 1) {
    return <components.ValueContainer {...props}>{children}</components.ValueContainer>;
  } else {
    return <components.ValueContainer {...props}>{nbValues} filter seçimi</components.ValueContainer>;
  }
};

export default SelectValueContainer;
